import Alpine from 'alpinejs'

export const initCollapsible = () => {
    Alpine.data('collapsible', (minHeight: number | undefined = 0, expandedState: boolean | undefined = false) => ({
        contentHeight: minHeight ? minHeight : 0,
        active: expandedState,
        init() {
            setTimeout(() => {
                if (expandedState) {
                    this.contentHeight = (this.$refs.content as HTMLElement).scrollHeight
                }
            }, 300)

            window.addEventListener(
                'resize',
                this.debounce(() => this.updateContentHeight())
            )
        },
        toggle() {
            this.active = !this.active
            this.contentHeight = this.active ? (this.$refs.content as HTMLElement).scrollHeight : minHeight
        },
        updateContentHeight() {
            if (this.active) {
                this.contentHeight = (this.$refs.content as HTMLElement).scrollHeight
            }
        },
        debounce(func: (...args: any[]) => void, timeout: number = 250) {
            let timer: number | undefined
            return (...args: any[]) => {
                if (timer !== undefined) {
                    clearTimeout(timer)
                }
                timer = window.setTimeout(() => {
                    func.apply(this, args)
                }, timeout)
            }
        },
    }))
}
